export default __webpack_public_path__ + "static/media/blog15.ac1f96fa.jpg";